import { InsetSize } from '@doordash/design-language';
import padStart from 'lodash.padstart';
import range from 'lodash.range';

var _FieldSizeSemantic, _FieldSizeString;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var FieldSize = {
  Small: InsetSize.XxSmall,
  Medium: InsetSize.XSmall,
  Large: InsetSize.Small
};
var TimeFieldSize = FieldSize;
var TextFieldSize = FieldSize;
var SelectSize = FieldSize;
var SearchFieldSize = FieldSize;
var PasswordFieldSize = FieldSize;
var NumberFieldSize = FieldSize;
var IdentificationFieldSize = FieldSize;
var EmailFieldSize = FieldSize;
var DateFieldSize = FieldSize;
var PhoneFieldSize = FieldSize;
var IntlPhoneFieldSize = FieldSize;
var FieldSizeSemantic = (_FieldSizeSemantic = {}, _defineProperty(_FieldSizeSemantic, FieldSize.Small, 'FieldSmall'), _defineProperty(_FieldSizeSemantic, FieldSize.Medium, 'FieldMedium'), _defineProperty(_FieldSizeSemantic, FieldSize.Large, 'FieldLarge'), _FieldSizeSemantic);
var FieldSizeString = (_FieldSizeString = {}, _defineProperty(_FieldSizeString, FieldSize.Small, 'Small'), _defineProperty(_FieldSizeString, FieldSize.Medium, 'Medium'), _defineProperty(_FieldSizeString, FieldSize.Large, 'Large'), _FieldSizeString);
var Countries = {
  CA: {
    label: 'Social Insurance Number',
    placeholder: '000-000-000',
    format: function format(numbers) {
      if (numbers.length >= 4 && numbers.length < 7) {
        return "".concat(numbers.substr(0, 3), "-").concat(numbers.substr(3));
      }

      if (numbers.length > 6) {
        return "".concat(numbers.substr(0, 3), "-").concat(numbers.substr(3, 3), "-").concat(numbers.substr(6));
      }

      return numbers;
    }
  },
  US: {
    label: 'Social Security Number',
    placeholder: '000-00-0000',
    format: function format(numbers) {
      if (numbers.length >= 4 && numbers.length < 6) {
        return "".concat(numbers.substr(0, 3), "-").concat(numbers.substr(3));
      }

      if (numbers.length > 5) {
        return "".concat(numbers.substr(0, 3), "-").concat(numbers.substr(3, 2), "-").concat(numbers.substr(5));
      }

      return numbers;
    }
  },
  AUS: {
    label: 'ABN',
    placeholder: '00 000 000 000',
    format: function format(numbers) {
      if (numbers.length >= 3 && numbers.length < 6) {
        return "".concat(numbers.substr(0, 2), " ").concat(numbers.substr(2));
      }

      if (numbers.length >= 6 && numbers.length < 9) {
        return "".concat(numbers.substr(0, 2), " ").concat(numbers.substr(2, 3), " ").concat(numbers.substr(5));
      }

      if (numbers.length > 8) {
        return "".concat(numbers.substr(0, 2), " ").concat(numbers.substr(2, 3), " ").concat(numbers.substr(5, 3), " ").concat(numbers.substr(8));
      }

      return numbers;
    }
  }
};
var HOURS = range(1, 13).map(function (hour) {
  return {
    name: String(hour),
    value: String(hour)
  };
});

var generateMinuteOptions = function generateMinuteOptions(_ref) {
  var step = _ref.step;
  return range(0, 60, step).map(function (minute) {
    return {
      name: padStart(String(minute), 2, '0'),
      value: String(minute)
    };
  });
};

var MINUTES = {
  One: generateMinuteOptions({
    step: 1
  }),
  Five: generateMinuteOptions({
    step: 5
  }),
  Ten: generateMinuteOptions({
    step: 10
  }),
  Fifteen: generateMinuteOptions({
    step: 15
  }),
  Twenty: generateMinuteOptions({
    step: 20
  }),
  Thirty: generateMinuteOptions({
    step: 30
  })
};
var PERIODS = [{
  name: 'AM',
  value: 'AM'
}, {
  name: 'PM',
  value: 'PM'
}];
var TimeFieldMinuteInterval = Object.keys(MINUTES).reduce(function (acc, key) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, key));
}, {});

export { Countries, DateFieldSize, EmailFieldSize, FieldSize, FieldSizeSemantic, FieldSizeString, HOURS, IdentificationFieldSize, IntlPhoneFieldSize, MINUTES, NumberFieldSize, PERIODS, PasswordFieldSize, PhoneFieldSize, SearchFieldSize, SelectSize, TextFieldSize, TimeFieldMinuteInterval, TimeFieldSize };
